import { useEffect, useState } from 'react';
import type { Editor } from '@tiptap/react';
import { estimateRuntime } from '../../../shared/runtime';
import { editorCutdownReason } from './cutdownCopy';

/** Why "Make a cutdown" is off in the editor's More menu, tracked live like
 *  the runtime badge. Null when a cutdown is possible. */
export function useCutdownReason(editor: Editor | null): string | null {
  const [reason, setReason] = useState<string | null>(null);
  useEffect(() => {
    if (!editor) return;
    const compute = () => setReason(editorCutdownReason(estimateRuntime(editor.getJSON())));
    compute();
    editor.on('update', compute);
    return () => {
      editor.off('update', compute);
    };
  }, [editor]);
  return reason;
}
